import { Typography, Chip, styled, TextField, Button } from '@material-ui/core';

export const FilterContainer = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  padding: 16,
  borderRadius: 20,
  width: 320,
  boxSizing: 'border-box',
  alignSelf: 'flex-start',
  position: 'sticky',
  top: theme.spacing(2),
}));

export const FilterHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
  gap: 8,
});

export const FilterHeaderActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const FilterTitle = styled(Typography)({
  fontFamily: 'Red Hat Display',
  fontWeight: 700,
});

export const ClearAllButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  letterSpacing: 0.5,
  minWidth: 0,
  padding: '4px 8px',
}));

export const SearchSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginBottom: 16,
});

export const SearchLabel = styled(Typography)({
  fontWeight: 700,
  fontSize: 14,
});

export const SearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#F5F7FF',
    borderRadius: 8,
    '& fieldset': {
      borderColor: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiOutlinedInput-input': {
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 14,
  },
}));

export const ChipsContainer = styled('div')({
  marginBottom: 16,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
});

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  '& .MuiChip-deleteIcon': {
    color: '#fff',
  },
}));

export const SectionHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 8,
});

export const SectionTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: 16,
});

export const EmptyMessage = styled(Typography)({
  padding: 2,
  textAlign: 'center',
});
